<template>
  <div>
    <BaseTitle :title="$t('content.view_syllabus')" :yearPeriode="titleData" />

    <div v-if="check === false">
      <NoData />
      <div class="d-flex justify-center align-center">
        <v-btn color="primary" class="btn-primary-custom" v-if="isStudent === false" @click="add">
          {{ $t('add') }}
        </v-btn>
      </div>
    </div>
    <div v-else>
      <v-card>
        <div>
          <v-card class="pa-5 d-flex justify-space-between align-items section-header active" flat tile>
            <div class="student-title">{{ nerd.schoolYear }}</div>
            <div v-if="(nerd.text === false && isStudent === false) || nerd.text === true">
              <template>
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <span dark v-bind="attrs" v-on="on">
                      <svg-icon icon="ic-moreaction-black" class="mt-1" />
                    </span>
                  </template>
                  <v-list>
                    <v-list-item v-if="isStudent === false">
                      <v-list-item-title class="text-dropdown" @click="edit()">{{ $t('edit') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="nerd.text === true">
                      <v-list-item-title class="text-dropdown" @click="downloadSyllabus()">{{ $t('download') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="isStudent === false">
                      <v-list-item-title class="text-dropdown-delete" :loading="loadingButton" @click="goDelete()">{{
                        $t('table.delete')
                      }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>

              <!-- Dialog Delete -->
              <v-dialog v-model="dialogDelete" persistent max-width="290">
                <v-card>
                  <v-card-title class="headline">{{ $t('delete_title') }}</v-card-title>
                  <v-card-text>{{ $t('delete_message') }}</v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialogDelete = false">{{ $t('disagree') }}</v-btn>
                    <v-btn text @click="deleteDetail">{{ $t('aggree') }}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </v-card>
          <div class="border-item pa-5">
            <div v-if="nerd.text === true">
              <v-card>
                <div class="move-list-content pa-10 " style="overflow-x: auto;">
                  <ul>
                    <li>
                      <article v-if="nerd" class="container mb-5" v-html="nerd.syllabus" />
                      <span v-else>-</span>
                    </li>
                  </ul>
                </div>
              </v-card>
            </div>
            <div v-if="nerd.text === false" class="move-list">
              <div class="move-list-content">
                <ul>
                  <li>
                    <iframe v-if="nerd.extension === 'pdf'" :src="nerd.fileUrl" class="viewer-content" />
                    <img
                      v-if="nerd.extension === 'png' || nerd.extension === 'jpg' || nerd.extension === 'jpeg'"
                      :src="nerd.fileUrl"
                      style="
                      width : 100%;
                      height : 800px;
                      flex: 1;
                    "
                    />
                    <iframe
                      v-if="
                        nerd.extension === 'doc' ||
                          nerd.extension === 'docx' ||
                          nerd.extension === 'xlsx' ||
                          nerd.extension === 'xls' ||
                          nerd.extension === 'ppt' ||
                          nerd.extension === 'pptx'
                      "
                      :src="`https://view.officeapps.live.com/op/embed.aspx?src=${nerd.fileUrl}`"
                      class="viewer-content"
                    />
                    <audio
                      v-if="nerd.extension === 'mp3'"
                      controls
                      style="
                      width : 100%;
                      flex: 1;
                    "
                      class="d-flex align-center justify-center text-center"
                      :src="nerd.fileUrl"
                    >
                      <source :src="nerd.fileUrl" type="audio/mpeg" />
                      Your browser does not support the audio element.
                    </audio>
                    <video
                      v-if="extension === 'mp4'"
                      controls
                      class="d-flex align-center justify-center text-center v"
                      style="
                      width : 100%;
                      flex: 1;
                    "
                      :src="nerd.fileUrl"
                    >
                      <source :src="nerd.fileUrl" type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </v-card>
      <div class="d-flex justify-end align-center mt-5">
        <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="back">{{ $t('cancel') }}</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';
import NoData from '@/components/table/NoData';

export default {
  name: 'StudentViewSyllabus',
  components: {
    BaseTitle,
    NoData
  },
  props: {
    isClass: {
      type: Boolean,
      default: false
    },
    isStudent: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      classLevel: 'QuizTeacher/classLevel',
      user: 'Auth/user',
      nameCourse: 'CourseList/nameCourse'
    })
  },
  sockets: {
    connect() {
      console.log('socket connected');
    },
    updateSyllabus({ classId, courseId }) {
      const { classId: currentClassId, courseId: currentCourseId } = this.$route.params;
      if (classId == currentClassId && courseId == currentCourseId) {
        this.getDataClass();
        this.$store.dispatch('general/showSuccessNotification', { message: 'Update Syllabus' });
        setTimeout(() => {
          if (this.check === true) {
            this.check = false;
          } else {
            this.check = true;
          }
          this.getDataClass();
        }, 400);
      }
    }
  },
  data: () => ({
    dataClass: '',
    check: false,
    nerd: '',
    loadingButton: false,
    dialogDelete: false,
    currentItem: '',
    titleData: ''
  }),
  methods: {
    getDataClass() {
      if (!this.$route.params.classSectionId) {
        this.$store
          .dispatch('Class/fetchClassroomCourseName', { classId: this.$route.params.classId, courseId: this.$route.params.courseId })
          .then(datas => {
            if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
              this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
                this.$store
                  .dispatch('Syllabus/getDataDetail', {
                    classroomId: resa.classroomId,
                    courseId: this.$route.params.courseId,
                    isStudent: this.isStudent
                  })
                  .then(res => {
                    if (res) {
                      this.check = true;
                      this.nerd = res;
                    }
                  });
                this.dataClass = resa;

                this.titleData = datas + ` ( ${resa.yearPeriode} ) `;
              });
            } else {
              this.$store.dispatch('Class/fetchListLiteDetail', this.$route.params.classId).then(resa => {
                this.$store
                  .dispatch('Syllabus/getDataDetail', {
                    classroomId: resa.classroomId,
                    courseId: this.$route.params.courseId,
                    isStudent: this.isStudent
                  })
                  .then(res => {
                    if (res) {
                      this.check = true;
                      this.nerd = res;
                    }
                  });
                this.dataClass = resa;
                this.titleData = datas + ` ( ${resa.yearPeriode} ) `;
              });
            }
          });
      } else {
        this.$store.dispatch('ClassSection/getListDetail', { classSectionId: this.$route.params.classSectionId }).then(datas => {
          if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
            this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
              this.$store
                .dispatch('Syllabus/getDataDetail', {
                  classroomId: resa.classroomId,
                  courseId: this.$route.params.courseId,
                  isStudent: this.isStudent
                })
                .then(res => {
                  if (res) {
                    this.check = true;
                    this.nerd = res;
                  }
                });
              this.dataClass = resa;

              this.titleData = datas.classroomName + ` ${datas.numberClass}` + ` ( ${resa.yearPeriode} ) `;
            });
          }
        });
      }
    },
    add() {
      const data = { ...this.$route.params, yearPeriode: this.dataClass.yearPeriode };
      localStorage.setItem('dataSyllabus', JSON.stringify(data));
      localStorage.setItem('backSyllabus', true);
      this.$router.push({ name: 'SyllabusCreate' });
    },
    edit() {
      localStorage.setItem('backSyllabus', true);
      this.$router.push({ name: 'SyllabusEdit', params: { id: this.nerd.syllabusId } });
    },
    back() {
      if (this.isStudent === false) {
        this.$router.push({ name: !this.$route.params.classSectionId ? 'TeacherMenuList' : 'TeacherMenuSectionList' });
      } else if (this.user.roleId === 5) {
        this.$router.push({ name: !this.$route.params.classSectionId ? 'StudentCourseList' : 'StudentMenuSectionList' });
      } else if (this.user.roleId === 6) {
        this.$router.push({ name: !this.$route.params.classSectionId ? 'AdvisorMenuList' : 'AdvisorSectionMenuSectionList' });
      }
    },
    downloadSyllabus() {
      this.$store
        .dispatch('Syllabus/downloadSyllabus', { id: this.nerd.syllabusId, isStudent: this.isStudent, potrait: this.nerd.potrait })
        .then(res => {
          let blob = new Blob([res.data], { type: 'application/pdf' });
          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);

          const { courseId } = this.$route.params;
          const courseName = this.dataClass.courses.find(item => item.courseId == courseId)?.name ?? '';
          const fileName = `Syllabus - ${this.dataClass.classroomName} - ${courseName}.pdf`;

          link.download = fileName;
          link.click();
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e));
    },
    goDelete() {
      this.dialogDelete = true;
      this.currentItem = this.nerd.syllabusId;
    },
    deleteDetail() {
      if (!this.currentItem) return false;

      this.loadingButton = true;
      this.$store
        .dispatch('Syllabus/destroy', this.currentItem)
        .then(({ data }) => {
          this.nerd = null;
          this.check = false;
          this.$store.dispatch('general/showSuccessNotification', data);
          this.currentItem = null;
          this.getDataClass();
          this.dialogDelete = false;
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => (this.loadingButton = false));
    }
  },
  created() {
    if (this.isClass) {
      this.getDataClass();
    } else {
      localStorage.removeItem('courseName');
    }
  }
};
</script>

<style lang="scss" scoped>
.section-header {
  border-radius: 4px 4px 0 0;

  &.active {
    background: #00bf63;
    .student-title {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
    }
  }

  &.disabled {
    background: #acacac;
    pointer-events: none;

    .student-title {
      color: #fff;
    }
  }
}
.pointer {
  cursor: pointer;
}
.move-list {
  height: 100%;

  &-title {
    background: #00bf63;
    color: #fff;
    font-family: Montserrat;
    font-weight: 800;
    border-radius: 8px 8px 0 0;
    padding: 10px;
    width: 100%;
  }

  &-content {
    border: 1px solid #d8d8d8;
    border-radius: 0 0 8px 8px;
    padding: 10px;
    background: #fff;
    overflow: scroll;
    overflow-x: hidden;
    width: 100%;
    height: 100%;
    line-height: 2em;

    ul {
      list-style: none;
      padding: 0;

      li {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #d8d8d8;
        padding: 10px 15px;
        align-items: center;

        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
}
.text-dropdown {
  cursor: pointer;
  &-delete {
    color: red;
    cursor: pointer;
  }
  &-grey {
    color: grey;
    cursor: pointer;
  }
}

.text-right {
  display: flex;
  justify-content: space-between;
  margin-left: 15px;
  margin-top: 10px;
  align-items: center;
  font-weight: bold;
}
.viewer {
  @extend %overlay;
  color: #fff;
  display: flex;
  flex-direction: column;
  z-index: 200;

  &-bar {
    display: flex;
    align-items: center;
    padding: 20px;
    background: rgba($color: #000000, $alpha: 0.5);
  }

  &-content {
    height: 800px;
    flex-basis: 100%;
    border: none;
  }
}

.succ {
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f2f3fc;
  text-align: center;
  font-family: Montserrat;
  font-weight: 500;

  &-featured {
    width: 100%;
    margin-bottom: 30px;
  }
}
</style>
